const FEATUREBASE_URL_PATTERN =
  /^https:\/\/griply\.featurebase\.app(?:[/?#].*)?$/;

export const isValidFeaturebaseUrl = (urlString: string): boolean =>
  FEATUREBASE_URL_PATTERN.test(urlString);
